// Module
var code = "<!DOCTYPE html> <html> <head> <meta charset=\"UTF-8\"> <title>select2</title> </head> <body> <script>window.location=\"https://select2.org/configuration\"</script> </body> </html>";
// Exports
module.exports = code;